import React from "react";
import Skeleton from "@mui/material/Skeleton";
import { AnimatePresence } from "framer-motion";
import { Users } from "lucide-react";
import ShopTeamMember from "./ShopTeamMember";

const ShopTeamPanel = ({
  isTeamLoading,
  members,
  users,
  onRemove,
  onEdit,
}) => {
  const totalCount = members.length + users.length;

  return (
    <section className="shop-panel shop-team-panel">
      <div className="shop-panel-heading">
        <div>
          <span className="shop-eyebrow">PEOPLE</span>
          <h2>Shop team</h2>
          <p>Manage the people who help run your shop.</p>
        </div>
        <span className="shop-team-count">
          {totalCount} {totalCount === 1 ? "person" : "people"}
        </span>
      </div>

      <div className="shop-team-list">
        {isTeamLoading &&
          Array.from({ length: 3 }, (_, index) => (
            <article className="shop-team-member" key={index}>
              <Skeleton variant="circular" width={48} height={48} />
              <div className="shop-team-member-copy">
                <Skeleton variant="text" width={150} height={22} />
                <Skeleton variant="text" width={210} height={17} />
              </div>
            </article>
          ))}
        <AnimatePresence initial={false}>
          {!isTeamLoading &&
            members.map((member) => (
              <ShopTeamMember
                key={member.id}
                member={member}
                type="member"
                onRemove={onRemove}
                onEdit={onEdit}
              />
            ))}
          {!isTeamLoading &&
            users.map((user) => (
              <ShopTeamMember
                key={user.id}
                member={user}
                type="user"
                onRemove={onRemove}
                onEdit={onEdit}
              />
            ))}
        </AnimatePresence>
      </div>

      {!isTeamLoading && !members.length && !users.length && (
        <div className="shop-team-empty" role="status">
          <span className="shop-team-empty-icon" aria-hidden="true">
            <Users size={20} />
          </span>
          <div className="shop-team-empty-copy">
            <strong>No team members yet</strong>
            <p>People you invite will appear here once they accept.</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default ShopTeamPanel;
